import { create } from 'zustand'
import { useGlobalFiltersStore } from 'core/store/useGlobalFiltersStore'

interface StoreTrajectoryFiltersState {
  targetYear: number | null
  setTargetYear: (targetYear: number | null) => void
  referenceStoreId: number | null
  setReferenceStoreId: (referenceStoreId: number | null) => void
}

const DEFAULT_FILTERS_STATE = {
  targetYear: null,
  referenceStoreId: null
}

export const useStoreTrajectoryFiltersStore = create<StoreTrajectoryFiltersState>()(set => ({
  ...DEFAULT_FILTERS_STATE,
  setTargetYear: targetYear => {
    set({ targetYear })
  },
  setReferenceStoreId: referenceStoreId => {
    set({ referenceStoreId })
  }
}))

useGlobalFiltersStore.subscribe((state, previousState) => {
  if (state.storeId === previousState.storeId) {
    return
  }

  useStoreTrajectoryFiltersStore.setState(currentState => ({
    ...currentState,
    referenceStoreId: null
  }))
})

export const resetStoreTrajectoryFiltersStore = () => {
  useStoreTrajectoryFiltersStore.setState(DEFAULT_FILTERS_STATE)
}
